import React from 'react';
import '../../src/styles/App.css';

const Hero = ({ currentPhrase }) => {
  const downloadCV = () => {
    const link = document.createElement('a');
    link.href = '/images/KumailCV.pdf'; // Your CV file path
    link.download = 'Kumail_CV.pdf'; // Filename for download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <header id="home" className="hero">
      <div className="container container-lg">
        <div className="hero-grid">

          {/* LEFT CONTENT */}
          <div className="hero-card">
            <div className="h1">
              Hi, I'm <span className="accent">Kumail Abbas</span>
            </div>
            <p className="lead">
              An <span className="type">{currentPhrase}</span> building scalable
              web applications and AI-powered solutions.
            </p>
            <div className="cta-row">
              <a href="#projects" className="btn btn-primary-custom me-2">View Projects</a>
              <a href="#contact" className="btn btn-ghost">Hire Me</a>
              <button onClick={downloadCV} className="btn btn-ghost ms-2">Download CV</button>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <aside className="profile-container">
            <img
              src="/images/profile-pic.png"
              alt="profile"
              className="profile"
            />

            {/* Social Links */}
            <div className="social-links" style={{ marginTop: '12px' }}>
              <a href="https://github.com/kumailabbasi" title="GitHub">
                <i className="fab fa-github"></i>
              </a>

          
            </div>

            {/* About Card */}
            <div style={{ marginTop: '70px' }} className="card-glass">
              <h5 style={{ color: 'var(--text)', margin: '0 0 6px' }}>About</h5>
              <p style={{ margin: 0, color: 'var(--muted)', fontSize: '14px' }}>
                AI & Software Engineer with experience in React, Python, FastAPI,
                ASP.NET, and automation systems. I build reliable, scalable solutions
                that solve real-world problems.
              </p>

              <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                <div style={{ fontSize: '12px', color: 'var(--muted)' }}>
                  <strong style={{ color: 'var(--text)' }}>Location</strong><br />
                  Pakistan
                </div>
                <div style={{ fontSize: '12px', color: 'var(--muted)' }}>
                  <strong style={{ color: 'var(--text)' }}>Email</strong><br />
                  abbasikumail747@gmail.com
                </div>
              </div>
            </div>
          </aside>

        </div>
      </div>
    </header>
  );
};

export default Hero;
